import { useSelector, useDispatch } from 'react-redux';
import { setYearFilterEvents, setYearFilterMedia } from '../../../../../redux/Reducers/newsReducer';
import styles from './NewsYearFilter.module.scss';
import classnames from 'classnames';

const YearFilter = ({ data }) => {
  const dispatch = useDispatch();
  const filterYear = useSelector((state) =>
    data === 'events' ? state.news.filterYearEvents : state.news.filterYearMedia,
  );

  const newsList = useSelector((state) => (data === 'events' ? state.news.events : state.news.media));
  const years = [...new Set(newsList.map((news) => new Date(news.date_to_show).getFullYear()))].sort((a, b) => b - a);

  const handleSetYearFilter = (year) => {
    return data === 'events' ? setYearFilterEvents(year) : setYearFilterMedia(year);
  };

  return (
    <div className={styles.box}>
      <h3 className={styles.title}>Архив</h3>
      <button
        onClick={() => dispatch(handleSetYearFilter(null))}
        className={classnames(filterYear === null ? [styles.allYears, styles.active] : [styles.allYears])}>
        Все года
      </button>

      {years.map((year) => {
        return (
          <button
            key={year}
            onClick={() => dispatch(handleSetYearFilter(year))}
            className={classnames(filterYear === year ? [styles.yearItem, styles.active] : [styles.yearItem])}>
            {year}
          </button>
        );
      })}
    </div>
  );
};

export default YearFilter;
